export default "__VITE_ASSET__qFUSyqIY__"